import { graphql } from "relay-runtime"

export const chUpdateProgressNotePointOfCare = graphql`
  mutation chUpdateProgressNotePointOfCareMutation($input: Ch_updateProgressNotePointOfCareInput!) {
    updateProgressNotePointOfCare: ch_updateProgressNotePointOfCare(input: $input) {
      ProgressNoteMutationOutput: ch_ProgressNoteMutationOutput {
        episodeOfCare {
          id
          updatedAt
        }
        progressNote {
          updatedAt
          betterDoc {
            isUsed
            rejectionReason
          }
          pointOfCare {
            medical
            actual
            reasonForChoosingActual
            isDoctorVisitAvoided
            careProviderId
            purpose {
              physicalExam
              laboratory
              instrumentalExamination
            }
            specialtyId
            careProviderSpecialty {
              id
              name
              specialtyTranslations {
                id
                language
                name
                specialtyId
              }
            }
            pointOfCareSpecialty {
              id
              word
              synonym
              specialtyTranslations {
                language
                name
              }
              careProviderSpecialty {
                id
                name
              }
            }
            timeToTreatType
            careProvider {
              id
            }
          }
        }
      }
      errors {
        ... on Error {
          message
        }
      }
    }
  }
`
